declare namespace $ {

	type $mol_number__minimal_width_shm_hitalama_map_fontsize_1 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['minimal_width'] >
	>
	type $mol_number__value_shm_hitalama_map_fontsize_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_fontsize['font_size'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__Dec_shm_hitalama_map_fontsize_3 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__Inc_shm_hitalama_map_fontsize_4 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_search__hint_shm_hitalama_map_fontsize_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_search['hint'] >
	>
	type $mol_search__query_shm_hitalama_map_fontsize_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_fontsize['font_size_selected'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_search__anchor_content_shm_hitalama_map_fontsize_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_search['anchor_content'] >
	>
	type $mol_search__suggests_shm_hitalama_map_fontsize_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_fontsize['font_size_suggests'] >
		,
		ReturnType< $mol_search['suggests'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_fontsize_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__minimal_height_shm_hitalama_map_fontsize_10 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_button_minor['minimal_height'] >
	>
	type $mol_button_minor__minimal_width_shm_hitalama_map_fontsize_11 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_button_minor['minimal_width'] >
	>
	type $mol_button_minor__event_click_shm_hitalama_map_fontsize_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_fontsize['font_size_inc'] >
		,
		ReturnType< $mol_button_minor['event_click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_fontsize_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_fontsize_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__minimal_height_shm_hitalama_map_fontsize_15 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_button_minor['minimal_height'] >
	>
	type $mol_button_minor__minimal_width_shm_hitalama_map_fontsize_16 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_button_minor['minimal_width'] >
	>
	type $mol_button_minor__event_click_shm_hitalama_map_fontsize_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_fontsize['font_size_dec'] >
		,
		ReturnType< $mol_button_minor['event_click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_fontsize_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_fontsize_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_fontsize extends $mol_view {
		font_size_selected( next?: string ): string
		font_size( next?: number ): number
		Font_size( ): $mol_number
		font_size_suggests( ): readonly(string)[]
		Search( ): $mol_search
		font_size_inc( next?: any ): any
		inc_icon( ): $mol_icon_chevron_up
		Inc( ): $mol_button_minor
		font_size_dec( next?: any ): any
		dec_icon( ): $mol_icon_chevron_down
		Dec( ): $mol_button_minor
		Inc_dec( ): $mol_view
		sub( ): readonly(any)[]
		font_size_options( ): readonly(number)[]
	}
	
}

//# sourceMappingURL=fontsize.view.tree.d.ts.map